// extracted by mini-css-extract-plugin
export default {"semiTitle":"item_semiTitle__T5rJk","lineButtons":"item_lineButtons__m6P6S","headers":"item_headers__7Y3uG","twoInLine":"item_twoInLine__xulhp","blokInputs":"item_blokInputs__x9TCH"};